<template>
  <div id="class-detail-lecture">
    <!-- 学科切换 -->
    <div v-if="!isPhone">
      <ul class="classtype">
        <li
        :style="category === item?'font-weight:600;background:white;color:#00C7BF':'background:rgba(10,201,193,1);'"
        v-for="(item,index) in subjectList.subject" :key="index" class="classtype_text" @click="findCategroy(item,(subjectList.subjectEnglish)[index])">{{item}}</li>
      </ul>
      <div class="grade_select">
        <div class="grade_selecttext" @click="findSelect" ref="mbMenu">
          {{gradeText}}
          <i class="fa fa-xiala"></i>
        </div>
        <div class="grade_list" v-if="gradeState">
          <!-- 年级切换 -->
          <div
           class="grade_listinfo"
            @click="checkGrade(item.name,index)"
            v-for="(item,index) in searchGradeList" :key="index"
            :class="gradeCheck===item.name?'gradecheck_yes':'gradecheck_no'"
            >
            {{item.name}}
            <i v-if="gradeCheck===item.name" class="el-icon-check"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 学科切换 -->
    <div v-if="isPhone" class="phone_nav">
      <ul class="phone_subject" >
        <li v-for="(item,index) in subjectList.subject"
        :class="category === item?'phone_checksubject':''"
        @click="findCategroy(item,(subjectList.subjectEnglish)[index])"
        :key="index" >{{item}}</li>
      </ul>
      <div class="phone_grade">
        <div @click="findSelect">年级</div>
        <div
          class="icon_down"
          :style="down_list?'transform: rotate(180deg);transition: 0.4s;':''"
          @click="findSelect"
        >
          <i class="el-icon-caret-bottom"></i>
        </div>
        <div class="phone_gradelist" v-if="gradeState">
        <div
            @click="checkGrade(item.name,index)"
            v-for="(item,index) in searchGradeList" :key="index"
            :class="gradeCheck===item.name?'gradecheck_yes':'gradecheck_no'"
          >
            {{item.name}}
            <i v-if="gradeCheck===item.name" class="el-icon-check"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="class-list"
      v-if="!!ClassCardInfo && ClassCardInfo.length != 0"
      v-loading="loading"
      element-loading-text="拼命加载中"
    >
      <div
        class="card"
        v-for="(item, index) in ClassCardInfo"
        v-bind:key="index"
        @click="nextPage(item)"
      >
        <ClassCard
          :classType="item.module"
          :title="String(item.title)"
          :classStatus="item.classStatus"
          :subject="item.subject"
          :date="item.date"
          :classProcess="item.classProcess"
          :time="item.time"
          :position="item.position"
          :price="item.price"
          :realPrice="item.realPrice"
          :ComponentsStyle="0"
          :groupState="item.groupState"
          :groupPrice="item.groupPrice"
          :classLabel="classrightLabel"
          :teacherList="item.teacher"
          :subTitle="String(item.subTitle)"
          :subSum="item.subSum"
          :virtual_price="item.virtual_price"
          :lecture="'lecture'"
          :carState="item.shoppingCarState"
          :isShowShoppingCar="item.isShowShoppingCar"
          :goodsId="item.goods_id"
        />
      </div>
    </div>
    <div class="class-list-empty" v-if="!ClassCardInfo || ClassCardInfo.length == 0">
      <div class="not-found-container">
        <div class="img">
          <img src="@/assets/img/notFound@2x.png" alt />
        </div>
        <div class="tips">暂无课程，请更换筛选条件</div>
      </div>
    </div>
    <div class="infinite-scroll" v-show="scorlloading">
      <span class="infinite-scroll-text">{{tip}}</span>
    </div>
  </div>
</template>
<script>
import ClassCard from '@/components/ClassCard'
import moment from 'moment'
import api from '@/api'
// import filters from '@/utils/filters'
// import utils from '@/utils/utils'
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      ClassCardInfo: [],
      loading: false,
      currentPage: 1,
      classrightLabel: 'live',
      gradeText: '',
      gradeCheck: '',
      gradeState: false,
      category: '',
      isPhone: false,
      down_list: false,
      screenWidth: document.documentElement.clientWidth,
      subject: '',
      onPullDown: true, // 下拉加载
      isEnd: true, // 下拉加载
      tip: '',
      scorlloading: false,
      searchGradeList: [],
      subjectType: [],
      subjectList: {}
    }
  },
  components: {
    ClassCard
  },
  methods: {
    // 处理年级学科关联
    handleGradeSubject () {
      const nowTime = parseInt(new Date().getTime() / 1000)
      api.getCourseLabel(nowTime).then(res => {
        const gradeArr = []
        const subjectArr = []
        res.data.map(i => {
          gradeArr.push(i.name)
        })
        const item = [...new Set(gradeArr)]
        for (let i = 0; i < item.length; i++) {
          const obj = {
            name: item[i],
            subject: [],
            subjectEnglish: []
          }
          for (let j = 0; j < res.data.length; j++) {
            if (item[i] === res.data[j].name) {
              for (let k = 0; k < res.data[j].subject.length; k++) {
                if (res.data[j].subject[k].value) {
                  subjectArr.push(res.data[j].subject[k].value)
                }
                if (obj.subject.indexOf(res.data[j].subject[k].title) === -1 && res.data[j].subject[k].title !== '全部') {
                  obj.subject.push(res.data[j].subject[k].title)
                  if (res.data[j].name === '小学') {
                    obj.subjectEnglish.push('P_' + res.data[j].subject[k].value)
                  } else if (res.data[j].name === '初中') {
                    obj.subjectEnglish.push('J_' + res.data[j].subject[k].value)
                  } else {
                    obj.subjectEnglish.push(res.data[j].subject[k].value)
                  }
                }
              }
            }
          }
          this.searchGradeList.push(obj)
        }
        this.subjectType = [...new Set(subjectArr)]
        if (gradeArr.indexOf('高中') > -1) {
          this.checkGrade('高中')
        }
      })
    },
    // 判断屏幕大小
    checkPhone () {
      const width = document.body.clientWidth
      if (width < 767) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    scroll () {
      var that = this
      var scrollTop = document.documentElement.scrollTop + document.body.scrollTop
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (
        scrollTop + windowHeight + 500 > scrollHeight &&
        that.onPullDown === true && that.isEnd === true
      ) {
        that.onPullDown = false
        that.currentPage = that.currentPage + 1
        this.getLiveList()
      }
    },
    nextPage (obj) {
      this.$router.push({
        name: 'ClassDetail',
        params: { classId: obj.id, classType: 'live' }
      })
      // const routeUrl = this.$router.resolve({
      //   name: 'ClassDetail',
      //   params: { classId: id, classType: 'live' }
      // })
      // window.open(routeUrl.href, '_blank')
      this.zhuGeEventTrack(this.zhugeEvents.COURSE_CARD_CLICK, [
        '直播课',
        obj.type,
        obj.course_belong,
        obj.id,
        obj.title,
        obj.classCardStatus,
        '无'
      ])
    },
    findCategroy (subjectName, subjectEnglish) {
      this.currentPage = 1
      this.ClassCardInfo = []
      this.category = subjectName
      this.subject = subjectEnglish
      this.getLiveList()
    },
    // 点击下拉
    findSelect () {
      this.gradeState = !this.gradeState
    },
    // 点击选择年级
    checkGrade (gradeName, index) {
      this.currentPage = 1
      this.ClassCardInfo = []
      this.gradeCheck = gradeName
      this.gradeText = gradeName
      this.gradeState = false
      let highIndex = 0 // eslint-disable-line no-unused-vars
      // 初始化数据
      for (let i = 0; i < this.searchGradeList.length; i++) {
        if (this.searchGradeList[i].name === '高中') {
          highIndex = i
        }
        if (this.searchGradeList[i].name === gradeName) {
          let subjectTemp = ''
          let subjectEnglishTemp = ''
          for (let j = 0; j < this.searchGradeList[i].subject.length; j++) {
            if (this.searchGradeList[i].subject[j] === '物理' && j !== 0) {
              subjectTemp = this.searchGradeList[i].subject[0]
              this.searchGradeList[i].subject[0] = this.searchGradeList[i].subject[j]
              this.searchGradeList[i].subject[j] = subjectTemp
              subjectEnglishTemp = this.searchGradeList[i].subjectEnglish[0]
              this.searchGradeList[i].subjectEnglish[0] = this.searchGradeList[i].subjectEnglish[j]
              this.searchGradeList[i].subjectEnglish[j] = subjectEnglishTemp
            }
          }
        }
      }
      const isHaveIndex = index === undefined
      this.subjectList = isHaveIndex ? this.searchGradeList[highIndex] : this.searchGradeList[index]
      this.category = isHaveIndex ? this.searchGradeList[highIndex].subject[0] : this.searchGradeList[index].subject[0]
      this.subject = isHaveIndex ? this.searchGradeList[highIndex].subjectEnglish[0] : this.searchGradeList[index].subjectEnglish[0]
      this.getLiveList()
    },
    closeSelect (e) {
      if (!this.isPhone && !this.$refs.mbMenu.contains(e.target)) {
        this.gradeState = false
      }
    },
    getLiveList (page) {
      this.loading = true
      this.classrightLabel = 'live'
      const params = {
        page: this.currentPage,
        type: '免费课',
        subject_type: this.subject,
        course_belong: '质心灵动量',
        num: 12
      }
      api
        .getLiveList(params)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.items
            const nowTime = parseInt(new Date().getTime() / 1000)
            this.totalPage = r.data.data.total_pages
            let result = [] // eslint-disable-line no-unused-vars
            result = item.map(item => {
              // 拼装状态
              // const quota = { total: item.quota, ordered: item.ordered }
              // const orderBeginAt = item.order_begin_at
              // const classStatus = utils.calcuQuotaText(quota, orderBeginAt, item.pre_days)
              let index = item.subs_info.filter(
                _item => _item.begin_at < nowTime
              ).length
              index = index === -1 ? 0 : index
              const subject = item.subject_type.includes('PHY')
                ? '物'
                : item.subject_type.includes('BIO')
                  ? '生'
                  : item.subject_type.includes('CHEM')
                    ? '化'
                    : item.subject_type.includes('MATH')
                      ? '数'
                      : ''
              const module = item.subject_type.includes('PHY')
                ? '物理'
                : item.subject_type.includes('BIO')
                  ? '生物'
                  : item.subject_type.includes('CHEM')
                    ? '化学'
                    : item.subject_type.includes('MATH')
                      ? '数学'
                      : ''
              // const type = item.time_cycle !== '' ? JSON.parse(item.time_cycle) : ''
              // const time = item.cycle === '无周期' ? item.cycle : item.cycle + type.map(_item => { return _item.begin_at + '-' + _item.end_at }).join(' ')
              let groupState = item.activity_type === 1 ? 1 : 2
              const groupPrice =
                item.activity_type === 1
                  ? item.activity_info.group_price / 100
                  : -1
              const groupEndTime =
                !item.activity_info
                  ? -1
                  : item.activity_info.group_end_time
              const subSum = item.subs_info.length
              if (item.group_setting === null && nowTime > groupEndTime) {
                groupState = 2
              }
              return {
                id: item.class_id,
                // classType: item.sub_type === 3 ? '同步班' : item.sub_type === 4 ? '强基班' : '竞赛班',
                module,
                title: item.subject,
                // classStatus: { text: classStatus.orderedText, style: classStatus.orderedStatus },
                subject,
                date:
                  moment.unix(item.begin_at).format('YYYY.MM.DD') +
                  '-' +
                  moment.unix(item.end_at).format('YYYY.MM.DD'),
                classProcess: `已进行${index}/${item.subs_info.length}`,
                // time,
                position: item.city,
                teacher: item.teachers_info,
                price: item.price / 100,
                realPrice: item.price / 100,
                groupState,
                groupPrice,
                subTitle: item.short_desp,
                subSum,
                virtual_price: item.virtual_price,
                shoppingCarState: !item.cart_exist,
                isShowShoppingCar: 1,
                goods_id: Number(item.goods_id),
                course_belong: item.course_belong,
                type: item.type,
                classCardStatus: nowTime < item.begin_at
                  ? '未开始'
                  : nowTime > item.end_at
                    ? '已结束'
                    : '进行中',
                isGroup: item.activity_info !== null && item.activity_info.group_set === 1 &&
              (item.activity_info.group_end_time === 0 || nowTime < item.activity_info.group_end_time)
              }
            })
            this.ClassCardInfo = this.ClassCardInfo.concat(result)
            if (item.length > 0) {
              this.isEnd = true
            } else {
              this.isEnd = false
            }
            this.$nextTick(() => {
              this.onPullDown = true
            })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
          this.tips = '连接失败，请稍后重试'
          this.scorlloading = true
        })
      this.loading = false
    }
  },
  watch: {
    screenWidth () {
      this.checkPhone()
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  mounted () {
    const _this = this
    _this.handleGradeSubject()
    // _this.getLiveList()
    if (_this.screenWidth < 767) {
      _this.isPhone = true
    } else {
      _this.isPhone = false
    }
    window.onresize = function () {
      _this.screenWidth = document.documentElement.clientWidth
    }
    document.addEventListener('click', this.closeSelect)
    window.addEventListener('scroll', this.scroll, true) // 监听（绑定）滚轮滚动事件
  },
  destroyed () {
    document.removeEventListener('click', this.closeSelect)
    window.removeEventListener('scroll', this.scroll, true)
  }
}
</script>
<style lang="scss">
#class-detail-lecture {
  .classtype {
    margin: auto;
    width: 540px;
    display: flex;
    justify-content: center;
    position: relative;
    top: -139px;
    z-index: 5;
    .classtype_text {
      list-style: none;
      width: 86px;
      height: 36px;
      border: 1px solid #6cded9;
      color: white;
      text-align: center;
      line-height: 36px;
      box-sizing: border-box;
      cursor: pointer;
      i {
        font-size: 10px;
        position: relative;
        top: -2px;
        left: 4px;
        cursor: pointer;
      }
    }
    .classtype_text:nth-child(1) {
      border-radius: 4px 0px 0px 4px;
      border-right: none;
    }
    .classtype_text:nth-child(3) {
      border-left: none;
    }
    .classtype_text:nth-last-child(1) {
      border-left: none;
      border-radius: 0px 4px 4px 0px;
    }
  }
  .grade_select {
    width: 1140px;
    margin: auto;
    position: relative;
    top: -177px;
    z-index: 4;
    .grade_selecttext {
      cursor: pointer;
      color: white;
      width: 100px;
      height: 36px;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 36px;
      i {
        font-size: 10px;
        position: relative;
        top: -2px;
        right: -5px;
      }
    }
    .grade_list {
      width: 130px;
      // height: 93px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 16px 0px rgba(48, 48, 48, 0.23);
      border-radius: 4px;
      border: 1px solid rgba(51, 51, 51, 0.1);
      position: absolute;
      left: -16px;
      top: 35px;
      .grade_listinfo {
        height: 46px;
        text-align: left;
        line-height: 46px;
        box-sizing: border-box;
        padding-left: 16px;
        cursor: pointer;
        i {
          color: rgba(0, 199, 191, 1);
          position: relative;
          right: -54px;
        }
      }
      .grade_listinfo:hover {
        background: rgba(51, 51, 51, 0.04);
      }
      .gradecheck_yes {
        color: rgba(0, 199, 191, 1);
        background: white;
        font-weight: 600;
      }
      .gradecheck_no {
        color: rgba(51, 51, 51, 1);
        // background:rgba(51,51,51,0.04);
      }
    }
  }
  .class-list {
    width: 1140px;
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    margin-bottom: 36px;
    margin-top: -171px;
    .card:not(:nth-child(3n)) {
      margin-right: calc(11% / 3);
    }
    .card {
      width: 30%;
      margin-top: 24px;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 40px 30px -30px #dbe3e7;
      }
    }
  }
}
@media (max-width: 767px) and (min-width: 300px) {
  #class-detail-lecture {
    .class-list {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: -1px;
      .card:not(:nth-child(3n)) {
        margin-right: 0;
      }
      .card {
        width: 100%;
      }
    }
    .phone_nav {
      background: white;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 11px 0px 4px;
      font-size: 14px;
      .phone_subject {
        display: flex;
        li {
          list-style: none;
          width: 52px;
          text-align: center;
          color: rgba(51, 51, 51, 0.6);
          position: relative;
        }
        .phone_checksubject:after {
          position: absolute;
          bottom: 0;
          left: 20px;
          right: 20px;
          height: 3px;
          width: 16px;
          content: "";
          background: #00c7bf;
          top: 23px;
        }
      }
      .phone_grade {
        width: 50px;
        color: rgba(51, 51, 51, 0.6);
        display: flex;
        justify-content: space-between;
        position: relative;
        .icon_down {
          font-size: 16px;
          color: rgba(51, 51, 51, 0.3);
          position: relative;
          top: 1px;
        }
        .phone_gradelist {
          width: 52px;
          position: absolute;
          background: white;
          top: 22px;
          z-index: 5;
          left: 3px;
          div {
            box-sizing: border-box;
            padding: 0px 0px 0px 5px;
          }
          .gradecheck_yes {
            color: rgba(0, 199, 191, 1);
            background: white;
          }
          .gradecheck_no {
            color: rgba(51, 51, 51, 1);
            background: rgba(51, 51, 51, 0.04);
          }
        }
      }
    }
  }
}
@media (max-width: 1372px) and (min-width: 768px) {
  #class-detail-lecture {
    .class-list {
      width: 760px;
      .card {
        width: 40%;
        margin-top: 24px;
      }
      .card:not(:nth-child(2n)) {
        margin-right: calc(23% / 2);
      }
    }
    .grade_select {
      width: 740px;
    }
  }
}
</style>
